import { calculateFinancialSupport, toCurrency } from "../../../helpers";
import {
  CalcFeeWithDiscount,
  IGetBranchBackEndModel,
  SumPriceAndOtherFeesSupports,
} from "../types";
import { SubmitButtonColor } from "../../wizard/types";

export const calcFeeWithDiscount: CalcFeeWithDiscount = ({
  fee,
  hasFeeDiscount,
  feeDiscountType,
  feeDiscountAmount,
  currency,
}) => {
  if (isNaN(fee)) {
    fee = 0;
  }

  const discount = calculateFinancialSupport(
    fee,
    hasFeeDiscount,
    feeDiscountType,
    feeDiscountAmount,
  );

  let calcFee = fee;

  if (!isNaN(+discount)) {
    calcFee -= +discount;
  }

  calcFee = calcFee < 0 ? 0 : calcFee;

  return {
    calcFee,
    hasSupport: calcFee < fee,
    feeWithCurrency: toCurrency(fee, currency, " ", "code"),
    calcFeeWithCurrency: toCurrency(calcFee, currency, " ", "code"),
    discountWithCurrency: toCurrency(discount, currency, " ", "code"),
  };
};

export const sumPriceAndOtherFeesSupports: SumPriceAndOtherFeesSupports = (
  price,
  hasPriceSupport,
  priceWithSupport,
  otherFees,
  hasOtherFeesSupport,
  otherFeesWithSupport,
  currencyId,
) => ({
  priceOtherFeesSum: price + otherFees,
  priceOtherFeesSumWithCurrency: toCurrency(
    price + otherFees,
    currencyId,
    " ",
    "code",
  ),
  priceOtherFeesWithSupportsSum: priceWithSupport + otherFeesWithSupport,
  priceOtherFeesWithSupportsSumWithCurrency: toCurrency(
    priceWithSupport + otherFeesWithSupport,
    currencyId,
    " ",
    "code",
  ),
  hasFeesSupport: hasPriceSupport || hasOtherFeesSupport,
});

export function getDeleteButtonConfigs(values) {
  const {
    injectedData: { approved, pending },
  } = values;

  if (approved + pending > 0) {
    return {
      submitButton: null,
      cancelButton: {
        text: "Close",
      },
    };
  }

  return {
    submitButton: {
      text: "Delete",
      color: SubmitButtonColor.Danger,
    },
    cancelButton: {
      text: "Close",
    },
  };
}

export function getBranchesNames(
  branches: IGetBranchBackEndModel[],
  branchIds: { branchId: string }[],
): string[] {
  return branchIds.map(
    (b) => branches.find((branch) => branch.id === b.branchId)!.name,
  );
}
